<template>
<div>
  <div class="container">
    <form action="" class="form-horizontal">
      <div class="form-group label">
        <h4>Crear Vehiculo</h4><br>
        <vs-input label="plate" type="text" class="inputx" v-model="vehiclePost.plate" /><br>
        <vs-select class="ps_select" placeholder="autocomplete" autocomplete label="Modelo" v-model="model">
          <vs-select-item :key="index" :value="item.id" :text="item.group_name" v-for="item,index in models"/>
        </vs-select><br>
        <vs-button class="bx bxs-paint-roll ml-3" @click="postCreate()" color="darkgreen" type="border" icon="add">Crear</vs-button>
      </div>
    </form>
  </div>
  <br><br>
  <vs-alert class="ps_alert" color="danger" v-if="show">
        {{msg}}
  </vs-alert>
  <vs-alert class="ps_alert" color="success" v-if="show1">
        {{msg}}
  </vs-alert>
</div>
</template>
<script>
import axios from 'axios'
export default {
    name: "vehicleAdd",
    props:{
    },
    components: {
},
    data:()=>({
    model: String,
    models: Array,
    msg: '',
    show: false,
    show1: false,
    vehiclePost: {
        "plate" : "",
        "vmodel_id" : Number,
    },
    error_msg: ''
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    postCreate(){
      this.vehiclePost.vmodel_id = this.model
      const url_api = this.$store.state.url_api
      axios.post(url_api + 'api/create/vehicle', this.vehiclePost).then(response => {
        console.log(response)
        if (response.data == 'isOk'){
          this.show = false
          this.show1 = true
          this.msg = 'successfully created'
        }
        else{
          this.show = true
          this.show1 = false
          this.msg = response.data
        }
      })
      .catch((error) => {
        this.show = true
        this.show1 = false
        this.msg = error.response.data
      })
    },
    getModel(){
      const url_api = this.$store.state.url_api
      axios.get(url_api + 'api/modelList').then(response => {
      this.models = response.data
      this.model = response.data[0].id
      })
      .catch((error) => {
        this.msg = error.response.data
      })
    },
  },
  mounted(){
    this.getModel()
  }
}
</script>
<style>
.ps_alert{
  margin-top: 1em;
}
  .label{
    text-align: left;
  }
.vs-select--label{
  color: #000000B3;
}
.vs-select--item{
  color: darkgreen;
}

element.style {
    font-weight: bold;
}
.vs-select-primary .vs-select--item.activex {
    background: rgb(23, 83, 65);
    color: white;
}
</style>